import { GlobalDefine } from "../globalDefine";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    [GlobalDefine.IS_NUMBER_PORTAL]() {
        return this.state.numberPortal && this.state.numberPortal.tenantJson ? true : false;
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
